import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";


const OrderDetail = () => {
  const [lead, setLead] = useState(null);
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

 

  const idToFetch = id;

  useEffect(() => {
    const fetchLeadData = async () => {
      setLoading(true);
      try {
        const response = await fetch("/server/dealer_backend/getAllTransactions"); // Replace with actual backend URL
        const data = await response.json();
        console.log(data);

        if (data.status === "success") {
          const filteredLead = data.data.find((item) => item.id === idToFetch);
          setLead(filteredLead);
        } else {
          console.error("Error fetching data:", data.error);
        }
      } catch (error) {
        console.error("Failed to fetch lead data:", error);
      }finally {
        setLoading(false);
      }
    };

    fetchLeadData();
  }, []);





  
  const LeadField = ({ label, value, icon }) => (
    <div className="form-group-field2">
      <label>{label}</label>
      <span>
        {icon && <span className="icon">{icon}</span>}
        {value || "—"}
      </span>
    </div>
  );







  return (

    loading ? (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    ) : (

    <div className="lead-container">
      {/* Lead Status Card */}
      
       
         
        





      

      {/* Lead Information Card */}
      <div className="lead-profile-container">
        {lead ? (
          <div className="lead-cards">
            {/* Left Card */}
            <div className="lead-card">
              <div className="form-group-field">
                <label className="dropdown-label">Transaction ID Owner</label>
                <span>{lead.Owner || "—"}</span>
              </div>
              <div className="form-group-field">
                <label>Modified By</label>
                <span className="email-link">{lead.Modified_By || "—"}</span>
              </div>

             

            </div>

            {/* Right Card */}

          </div>
        ) : (
          <p className="loading-text">Loading transaction details...</p>
        )}
      </div>


      <div className="lead-container2">
        <h3 className="lead-title">Transaction ID Information</h3>
        <hr className="lead-divider" />
        {lead && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-800">

    {/* Left Column */}
    <div className="space-y-3">
      <LeadField label="Transaction Name" value={lead?.Name}/>
      <LeadField label="Email" value={lead?.Email} />
      <LeadField label="Title" value={lead?.Title || "—"} />
      <LeadField
        label="Created By"
        value={
          <>
            {lead?.Created_By || "—"}
            <br />
            {/* {lead?.Created_Date || "—"} */}
          </>
        }
      />
      <LeadField label="Phone No." value={lead?.Phone || "—"} />
      <LeadField label="Associated Contact" value={lead?.Associated_Contact || "—"} />
      <LeadField label="Nationality" value={lead?.Nationality } />
    </div>

    {/* Right Column */}
    <div className="space-y-3">
      <LeadField label="Transaction ID Owner" value={lead?.Owner } />
      <LeadField label="Amount" value={lead?.Amount || "—"} />
      <LeadField label="First Name" value={lead?.First_Name } />
      <LeadField label="Last Name" value={lead?.Last_Name } />
      <LeadField
        label="Modified By"
        value={
          lead?.Modified_By || "—"
          
           
        
        }
      />
      <div className="form-group-field2">
        <label className="block text-gray-700 font-medium">Mobile No.</label>
        <span className="inline-flex items-center space-x-1">
          <FaPhoneAlt className="text-green-500" />
          <span>{lead?.Mobile_No }</span>
        </span>
      </div>
      <LeadField
        label="Associated Deal"
        value={
            lead?.Associated_Deal
           
           
        }
      />
    </div>
  </div>
)}





      


      </div>




    

    </div>
    )


  );
};

export default OrderDetail;
